const LEGAL_PAGE_PATHS = new Set(["/privacy-policy", "/terms-and-conditions"]);

function normalizePathname(pathname?: string | null): string {
  if (!pathname) return "";

  const [pathOnly] = pathname.split(/[?#]/, 1);
  if (!pathOnly) return "";

  if (pathOnly === "/") return "/";
  return pathOnly.endsWith("/") ? pathOnly.slice(0, -1) : pathOnly;
}

export function isLegalPagePath(pathname?: string | null): boolean {
  const normalized = normalizePathname(pathname);
  return LEGAL_PAGE_PATHS.has(normalized);
}
